import { Link } from 'react-router-dom';
import { Linkedin, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-50 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <img 
              src="https://customer-assets.emergentagent.com/job_strata-specialists/artifacts/f7davlug_image.png" 
              alt="Growth Talent Group" 
              className="h-12 w-auto mb-4"
            />
            <p className="text-gray-600 text-sm mb-4">
              Australia's leading specialist recruitment agency for real estate, property, and strata management professionals.
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://linkedin.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-600 hover:text-brand-400 transition-colors duration-200"
              >
                <Linkedin size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-gray-900 font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-600 hover:text-brand-400 text-sm transition-colors duration-200">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-600 hover:text-brand-400 text-sm transition-colors duration-200">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-600 hover:text-brand-400 text-sm transition-colors duration-200">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/jobs" className="text-gray-600 hover:text-brand-400 text-sm transition-colors duration-200">
                  Jobs
                </Link>
              </li>
              <li>
                <Link to="/careers" className="text-gray-600 hover:text-brand-400 text-sm transition-colors duration-200">
                  Join Our Team
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-gray-600 hover:text-brand-400 text-sm transition-colors duration-200">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-600 hover:text-brand-400 text-sm transition-colors duration-200">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-gray-600 font-bold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start text-gray-600 text-sm">
                <Mail size={16} className="mr-2 mt-1 text-brand-400" />
                <a href="mailto:info@growthtalentgroup.com.au" className="text-gray-600 hover:text-brand-400 transition-colors duration-200">
                  info@growthtalentgroup.com.au
                </a>
              </li>
              <li className="flex items-start text-gray-600 text-sm">
                <Phone size={16} className="mr-2 mt-1 text-brand-400" />
                <span>1300 GROWTH</span>
              </li>
              <li className="flex items-start text-gray-600 text-sm">
                <MapPin size={16} className="mr-2 mt-1 text-brand-400" />
                <span>Servicing Australia Wide</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-200 mt-8 pt-8 text-center">
          <p className="text-gray-600 text-sm">
            © {new Date().getFullYear()} Growth Talent Group. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
